module.exports = __webpack_public_path__ + "img/produit_eco.71c5ee2a.png";